import { fieldIconMap } from "./FieldIconMap";

export const FieldTypes = Object.keys(fieldIconMap)
  .filter((x) => x !== "Section")
  .sort((a, b) => a.localeCompare(b));
